export const SPANISH_LOCALE = 'es-us';
export const HAITIAN_CREOLE_LOCALE = 'ht-ht';
